import React from 'react'
import { PersonDto } from '../api/person/models/PersonDto'
import { getProfilePicUrl } from '../utils/personUtils'

interface PersonSmallPicProps {
    person: PersonDto
    size?: string
}

function PersonSmallPic({
    person,
    size = '60px',
}: PersonSmallPicProps): React.JSX.Element {
    return (
        <div className="person-small-pic-container">
            {getProfilePicUrl(person) ? (
                <img
                    src={getProfilePicUrl(person)}
                    alt={`${person.firstName} ${person.lastName}`}
                    style={{ width: size, height: size }}
                    className={`object-cover rounded-full`}
                    onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
                        e.currentTarget.onerror = null // Prevent infinite loop if fallback image also fails
                        e.currentTarget.src = '/no-profile-pic.png'
                    }}
                />
            ) : (
                <img
                    src="/no-profile-pic.png"
                    alt={`${person.firstName} ${person.lastName}`}
                    style={{ width: size, height: size }}
                    className="object-cover rounded-full"
                />
            )}
        </div>
    )
}

export default PersonSmallPic
